import '../modalWrapper.scss';
import './register.scss';

import Metamask from "../../../../assets/images/logos/metamask.png";
import Tron from "../../../../assets/images/logos/tron.png";
import Register from "../../../../assets/images/logos/register.png";

import React, { FunctionComponent, useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../../../features';
import { Button } from '../../button/button';
import { getBlockchainAddress, getBlockChainVerificationPharse, getIncreaseModalStep, getIsComingFromMetamask, getUserPhrase, makeBlockChainSignin, makeBlockchainSignup, makeRegisterAndLogin, setIncreaseModalStep, setIsComingFrmoBlockchain, setBlockChainAddress, setNetwork, getUserSignature, getBlockchainNetwork } from '../../../../store/RegisterSlice';
import { listNetworks, RegisterPhrases } from '../../../../types/register';

import { validate } from 'multicoin-address-validator';
import { 
    addSpanErrorMessage,
    getNotificationButtonLoad, 
    getSpanErrorMessage, 
    setNotificationButtonLoad } from '../../../../store/NotificationSlice';
import { useStepper } from '../../../../features/stepper';
import { PasswordField } from './components/password';
import { NicknameField } from './components/nickname';
import { getAppMobileStatus } from '../../../../store/AppSlice';
import walletConnector from '../../../../features/wallet-connector';
import { connectWallet } from '../../../../store/WalletSlice';

type RegisterLoginModalPorps = {
    isRegister?: boolean,
    increaseStep : () => void,
    decreaseStep : () => void,
}

export type RegisterProps = {
    increaseStep : () => void,
    decreaseStep : () => void,
}

const timerExpired = 3000;

export const RegisterWrapper : React.FC = () => {

    const dispatch = useAppDispatch();
    const [step, increaseStep, decreaseStep] = useStepper(0);

    const blockChainRegister = useAppSelector(getIncreaseModalStep);

    useEffect( () => {
        if (blockChainRegister) {
            increaseStep();
            dispatch(setIncreaseModalStep(false));
        }
    }, [blockChainRegister])

    const Component = [
        ModalRegisterSelect,
        ModalRegisterOrLogin
    ][step];
    
    return (
        <>
            <div className="modal-login">
                <div className="modal">
                    <Component increaseStep={increaseStep} decreaseStep={decreaseStep}/>
                </div>
            </div>
        </>
    )
}

export const ModalRegisterSelect: FunctionComponent<RegisterProps> = ({increaseStep, decreaseStep}) => {

    const dispatch      = useAppDispatch();
    const isMobile      = useAppSelector(getAppMobileStatus);

    // METAMASK
    const btnhandler = async () => {
        dispatch( setNetwork('eth_flow') );
        dispatch( connectWallet() );
    };

    // TRON
    const tronLinkHandler = async () => {
        
        dispatch(setNetwork('tron_flow'));

        if (window.tronWeb && window.tronWeb.ready) {
            try {
                const address = window.tronWeb.defaultAddress.base58;

                await dispatch( setIsComingFrmoBlockchain(true));
                await dispatch( setBlockChainAddress(address));
                await dispatch( getUserPhrase(address) );
                await dispatch( makeBlockChainSignin() );

            } catch (err) {
                console.error("Failed to get TronLink address:", err);
                alert("Error connecting to TronLink");
            }

        } else {
            alert("Please install or unlock TronLink wallet.");
        }
    };

    const noMetamaskHandler = () => {
        dispatch( setIsComingFrmoBlockchain(false))
        dispatch( setBlockChainAddress(''))
        increaseStep();
    }

    return (
        <div className="modal-select">
            <div className="wrapper-register-selection" onClick={noMetamaskHandler}>
                <img src={Register} alt="" />
                <h2>Personalizado</h2>
                Use seus dados para criar um registro
            </div>
            <hr />
            <div className='flex flex-column flex-space-around-inverted'>
                <p>Conecte sua carteira</p>

                { isMobile && 
                    <p className='alert alert-warning'>apenas disponivel no desktop</p>
                }
                { !isMobile && <>
                    <div className="flex flex-center gap-5">
                        <div className="wrapper-register-selection-wallet" onClick={btnhandler}>
                            <img src={Metamask} alt='metamask' />
                        </div>
                        <div className="wrapper-register-selection-wallet" onClick={tronLinkHandler}>
                            <img src={Tron} alt="" />
                        </div>
                    </div>
                </> }
            </div>
        </div>
    )
}

export const ModalRegisterOrLogin: FunctionComponent<RegisterLoginModalPorps> = ({ isRegister, increaseStep, decreaseStep }) => {

    const dispatch = useAppDispatch();
    
    const isButtonLoading           = useAppSelector(getNotificationButtonLoad);
    const spanErrorMessageDispatch  = useAppSelector(getSpanErrorMessage);
    const isFromBlockchain          = useAppSelector(getIsComingFromMetamask);
    const blockChainAddress         = useAppSelector(getBlockchainAddress);
    const hasPhrase                 = useAppSelector(getBlockChainVerificationPharse);

    const [hash, setHash]           = useState('');
    const [nick, setNick]           = useState('');
    const [pass, setPass]           = useState('');
    const [hashError, setHashError] = useState<boolean>(false);
    const [isLogin, setIsLogin]     = useState(isRegister || false);
    const [network, setNetwork]     = useState('');
    const [spanErrorMessage]        = useState(``);
    const [isBlockchain]            = useAppSelector(getBlockchainNetwork)

    const [showErrorSpan, setShowErrorSpan]         = useState(false);
    const [walletvalidation, setWalletValidation]   = useState(false);
    const [formSubmitted, setFormSubmitted]         = useState<boolean>(false);

    const networks  = listNetworks;
    const phrases   = RegisterPhrases;

    const cat = isLogin ? 'isLogin' : 'isRegister';
 
    const handleClickLoginOrRegister = async () => {
        
        dispatch(addSpanErrorMessage(''));
        setFormSubmitted(false);

        if ((nick === null || nick === '' || nick === undefined) && !isLogin) {
            setSpanError('nick'); 
            const timer = setTimeout( () => {
                clearTimeout(timer);
            }, timerExpired);
            return false;
        }
        if (hash === null || hash === '' || hash === undefined) {
            setSpanError('hash'); 
            setHashError(true);
            const timer = setTimeout( () => {
                setHashError(false);
                clearTimeout(timer);
            }, timerExpired);
            return false;
        }
        console.dir(isBlockchain);
        if (pass === null || pass === '' || pass === undefined) {
            if (!isBlockchain) {
                setSpanError('pass'); 
                const timer = setTimeout( () => {
                    clearTimeout(timer);
                }, timerExpired);
                return false;
            }
        }
        console.dir('log')
        const isVerified = validateFields();
        console.dir(isVerified);

        if (validateFields()) {
            try {
                setFormSubmitted(false);
                dispatch(setNotificationButtonLoad(true))
                if (isFromBlockchain) dispatch(makeBlockchainSignup(pass, nick))
                else dispatch(makeRegisterAndLogin(hash, pass, isLogin, nick))
            } catch (err) {
                dispatch(setNotificationButtonLoad(false))
                alert(" Register or login error : " + err)
            }
        }
            
    }

    const toggleForm = () => {
        setIsLogin(!isLogin);
    }

    const setSpanError = (cat:string) => {

        if (cat === 'nick') dispatch(addSpanErrorMessage('Erro: por favor adicione um apelido para sua conta'));
        if (cat === 'hash') dispatch(addSpanErrorMessage('Erro: por favor digitar o hash da sua carteira'));
        if (cat === 'pass') dispatch(addSpanErrorMessage('Erro: senha inválida, tente novamente'));

        setShowErrorSpan(true);
        const timer = setTimeout( () => {
            dispatch(addSpanErrorMessage(''));
            setShowErrorSpan(false);
            clearTimeout(timer);
        }, timerExpired);
    }

    useEffect(() => {
        if (spanErrorMessage !== "") {
            setShowErrorSpan(true);
            setFormSubmitted(false);
        }
        if (blockChainAddress) handleWalletVerification(blockChainAddress);
    }, [spanErrorMessage,blockChainAddress])
   

    const handleWalletVerification = (wallet: string) => {

        if (!isButtonLoading) {
            setHash(wallet);
            let network = '';

            if (wallet) {
                if (wallet[0].toLowerCase().includes("t")) network = "TRX"
                if (wallet[0].toLowerCase().includes("0")) {
                    if (wallet[1] && wallet[1].toLowerCase().includes("x")) network = "ETH"
                }
                if (network) {
                    const isValid = validate(wallet, network);
                    setWalletValidation(isValid);
                    const net = networks.filter(nets => nets.tag === network)[0].name;
                    setNetwork(net)
                }
            }
        }

    }

    const validateFields = () => {
        let a = true;
        if (pass === null || pass === '' || hash === null || hash === '') {
            if (!isBlockchain) a = false;
        } 
        if (!isLogin) if (nick === null || nick === '') a = false;
        console.dir(a);
        return a;
    }
    
    return (
        
        <div className="form">
            <legend>
                <h1>
                    {phrases[cat].title}
                    <small>
                        {phrases[cat].helper}
                    </small>
                </h1>
            </legend>
            <fieldset>

                { isFromBlockchain && <>
                    <p className='isMetamask'>{ hash }</p>
                </>}

                {!isLogin && (
                    <>
                        <NicknameField onChangeCallback={setNick} formwasSubmitted={formSubmitted}></NicknameField>
                    </>
                )}

                {!isFromBlockchain && <>

                    <div className="form-input-wrapper networks-list">
                        <label htmlFor="user">Carteira <small>(Endereço hash da carteira)</small></label>
                        <input type="text" id="user" 
                            className={`bottomPad' ${hashError ? 'has-error' : ''}`}
                            onChange={e => handleWalletVerification(e.target.value)} 
                            value={hash} />
                        {hash && hash.length > 0 && (
                            <div className={`validations ${!walletvalidation ? 'text-danger' : 'text-success'}`}>
                                Carteira {walletvalidation ? 'válida' : 'inválida'} <br/>
                                <span className={showErrorSpan ? 'text-error' : 'text-info'}>Rede</span>: {network}<br />
                            </div>
                        )}
                    </div>
                
                    <PasswordField onChangeCallback={setPass} formwasSubmitted={formSubmitted}></PasswordField>
                </>}

                <span className={`text-danger ${spanErrorMessageDispatch ? 'active' : ''}`}>{spanErrorMessageDispatch}</span>

                <Button
                    label={phrases.button[cat]}
                    onClick={() => handleClickLoginOrRegister()}
                    type={cat === 'isRegister' ? 'register' : 'login' }
                    loading={isButtonLoading}/>
                <Button
                    label={phrases[cat].change}
                    onClick={toggleForm}
                    type="swap"
                    loading={isButtonLoading}/>
            </fieldset>
        </div>
        
    )
}